import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { reduxForm, change, Field, FieldArray } from 'redux-form';
import ReactTable from 'react-table';
import { Checkbox } from 'semantic-ui-react';
import { connect } from 'react-redux';
import _ from 'lodash';

import {
  RecipePreparationTableFieldEnum as Fields,
  RecPrepRecipeFieldEnum as RecipeFields,
} from 'Common/FieldEnum';
import { RECIPE_PREPARATION_TABLE_FORM_NAME, InputMode } from 'Common/FormEnum';
import {
  ReactTableWrapperColumnProperties,
  ReactTableVerticalAlignCenter,
  ReactTableWrapperAlignCenter,
} from 'Common/Constants';
import { InputField, PopupField, CheckboxField } from 'Common/SemanticWrapper';
import { caseInsensitiveFilter } from 'Common/GridHelper';
import * as RecPrepSelectors from 'Pages/recipepreparation/state/selectors';

class RecipeTable extends Component {
  static propTypes = {
    loading: PropTypes.bool,
  };

  static defaultProps = {
    loading: false,
  };

  onAllCheckboxClick = (e, data) => {
    const { dispatch, fields } = this.props;
    fields.forEach(f => {
      dispatch(
        change(
          RECIPE_PREPARATION_TABLE_FORM_NAME,
          `${f}.${RecipeFields.Selected}`,
          data.checked
        )
      );
    });
  };

  columns = [
    {
      Header: rows => {
        const { allSelected, indeterminate } = this.props;
        return (
          <Checkbox
            checked={allSelected}
            indeterminate={indeterminate}
            onClick={this.onAllCheckboxClick}
          />
        );
      },
      id: RecipeFields.Selected,
      accessor: row => {
        const { fields } = this.props;
        const path = _.toPath(row);
        const index = Number(path[1]);
        const field = fields.get(index);
        return _.get(field, RecipeFields.Selected, false);
      },
      Cell: row => {
        return (
          <Field
            name={`${row.original}.${RecipeFields.Selected}`}
            component={CheckboxField}
          />
        );
      },
      ...ReactTableWrapperAlignCenter,
      width: 50,
      filterable: false,
      sortable: false,
    },
    {
      Header: 'Name',
      id: RecipeFields.Name,
      accessor: row => {
        const { fields } = this.props;
        const path = _.toPath(row);
        const index = Number(path[1]);
        const field = fields.get(index);
        return _.get(field, RecipeFields.Name);
      },
      ...ReactTableWrapperColumnProperties,
      ...ReactTableVerticalAlignCenter,
      Cell: row => (
        <Field
          name={`${row.original}.${RecipeFields.Name}`}
          component={PopupField}
        />
      ),
    },
    {
      Header: 'Servings',
      accessor: RecipeFields.NumberOfPortion,
      resizable: false,
      sortable: false,
      width: 200,
      Cell: row => (
        <Field
          name={`${row.original}.${RecipeFields.NumberOfPortion}`}
          maxLength={3}
          component={InputField}
          fluid={true}
          mode={InputMode.Integer}
          showOnlyTouchedError={true}
          hideEmptyError={true}
        />
      ),
    },
  ];

  render() {
    const {
      fields,
      loading,
      meta: { error },
    } = this.props;

    return (
      <Fragment>
        <ReactTable
          className="-striped -highlight"
          loading={loading}
          data={fields}
          columns={this.columns}
          defaultPageSize={10}
          defaultFilterMethod={caseInsensitiveFilter}
        />
        {error && (
          <span className={'text-red input--message-error'}>{error}</span>
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  allSelected: RecPrepSelectors.getAllSelected(state),
  indeterminate: RecPrepSelectors.getIndeterminate(state),
});
RecipeTable = connect(mapStateToProps)(RecipeTable);

export const TableForm = ({ loading }) => (
  <FieldArray name={Fields.Recipes} component={RecipeTable} loading={loading} />
);

const asyncValidate = values => {
  return new Promise((resolve, reject) => {
    const errors = {};
    const recipes = values[Fields.Recipes] || [];
    const recipeErrors = [];
    if (Array.isArray(recipes)) {
      recipes.forEach((recipe, index) => {
        const error = {};
        const selected = _.get(recipe, RecipeFields.Selected);
        if (selected) {
          const numberOfPortion = _.get(recipe, RecipeFields.NumberOfPortion);
          if (Number(numberOfPortion) < 1) {
            error[RecipeFields.NumberOfPortion] = 'Servings is required.';
          }
        }
        recipeErrors[index] = error;
      });
    }

    const arrayHasError = recipeErrors.some(error => !_.isEmpty(error));

    if (arrayHasError) {
      // if there was an error for any row, set array field error
      recipeErrors._error = arrayHasError
        ? 'Servings is required for selected recipes.'
        : undefined;
      errors[Fields.Recipes] = recipeErrors;

      reject(errors);
    }
    resolve();
  });
};

const RecipeTableForm = reduxForm({
  asyncValidate,
  form: RECIPE_PREPARATION_TABLE_FORM_NAME,
  enableReinitialize: true,
})(TableForm);

export { RecipeTableForm };



// WEBPACK FOOTER //
// ./src/pages/recipepreparation/components/RecipeTableForm.js